// extracted by mini-css-extract-plugin
export default {"storeHero":"hero__storeHero__enKBK"};